import { actionCreatorFactory } from 'typescript-fsa'
import { Machine } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerMachines = actionCreator<Machine[]>('registerMachines')
